import { Debug } from "@sc07-canvas/lib/debug";
import { motion, useReducedMotion } from "framer-motion";
import { Info, Wrench } from "lucide-react";

import { useAppContext } from "@/contexts/AppContext";
import { usePanel } from "@/contexts/PanelContext";

import { useIsMobile } from "../../hooks/useIsMobile";
import { Button } from "../core/Button";
import { EventDatesHeader } from "../EventInfo";
import { SIDEBAR_SPRING } from "../SidebarBase";
import { AccountStanding } from "./AccountStanding";
import { useSidebarWidth } from "./useSidebarWidth";

export const HeaderLeft = () => {
  const Panel = usePanel();
  const { settings } = useAppContext();
  const compactButtons = settings.get["ui.compactButtons"];
  const reduceMotion = useReducedMotion() ?? false;
  const sidebarWidth = useSidebarWidth("Left");
  const isMobile = useIsMobile();
  const offsetForSidebar = Boolean(
    !isMobile &&
      Panel.state.info &&
      settings.get["ui.adaptElementsToSidebar"],
  );

  return (
    <motion.div
      animate={{ x: offsetForSidebar ? sidebarWidth : 0 }}
      className="header-left box gap-2 flex flex-col"
      transition={reduceMotion ? { duration: 0 } : SIDEBAR_SPRING}
    >
      <EventDatesHeader />
      <div className="gap-2 flex">
        <AccountStanding />
        <Button
          aria-label="Info"
          aria-pressed={Boolean(Panel.state.info)}
          className={[
            "header-mobile-overflow-action",
            "header-action-button",
            compactButtons && "header-action-button--compact",
            Panel.state.info && "is-active",
          ]
            .filter(Boolean)
            .join(" ")}
          onPress={() =>
            Panel.dispatch(["info", Panel.state.info ? undefined : true])
          }
        >
          <Info aria-hidden="true" size={18} />
          <p className="header-button-label header-button-label--short">Info</p>
        </Button>
        {import.meta.env.DEV && (
          <Button
            aria-label="Debug Tools"
            className={`header-mobile-overflow-action header-action-button${compactButtons ? " header-action-button--compact" : ""}`}
            onPress={() => Debug.openDebugTools()}
          >
            <Wrench aria-hidden="true" size={18} />
            <p className="header-button-label">Debug Tools</p>
          </Button>
        )}
      </div>
    </motion.div>
  );
};
